/**
 * Enum-like constants for the course Table-of-Contents progress status.
 *
 * NEW enum for the ToC tree — do NOT reuse `KC_STATUS` from `radar.constants.ts`
 * (that enum models the KC-detail timeline and has different members). Use the
 * `TOC_STATUS` members (e.g. `TOC_STATUS.MASTERED`) instead of raw string
 * literals so renames are mechanical and unknown values fail at compile time.
 */
export const TOC_STATUS = {
  NOT_STARTED: 'NOT_STARTED',
  IN_PRACTICE: 'IN_PRACTICE',
  IN_REVIEW: 'IN_REVIEW',
  MASTERED: 'MASTERED',
  BLOCKED: 'BLOCKED',
} as const;

export type TocStatus = typeof TOC_STATUS[keyof typeof TOC_STATUS];
